import { Routes } from '@angular/router';
import { Home } from './home/home';
import { About } from './about/about';
import { Features } from './features/features';
import { Downloads } from './downloads/downloads';
import { Faq } from './faq/faq';
import { Policies } from './policies/policies';
import { Contact } from './contact/contact';
import { Blog } from './blog/blog';

export const routes: Routes = [
    { path: '', component: Home },
    { path: 'about', component: About },
    { path: 'features', component: Features },
    { path: 'downloads', component: Downloads },
    { path: 'faq', component: Faq },
    { path: 'policies', component: Policies },
    { path: 'contact', component: Contact },
    { path: 'blog', component: Blog },
    // Ruta pública de alarma compartida — lazy load, debe ir antes del catch-all
    { path: 'a/:id', loadComponent: () => import('./public-alert/public-alert').then(m => m.PublicAlert) },
    { path: '**', redirectTo: '' }
];
